import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal } from "../Modal/Modal";
import { Heading } from "../Heading/Heading";
import { Button } from "../Button/Button";
import { InputField } from "../InputField/InputField";
import { useState } from "react";
import { trackEvent } from "../../../helpers/analytics-helpers";
import { COLORS } from "../../../assets/constants/styles";
import { sendDemoRequest } from "../../../api/emailApi";

export const DemoModal = ({ isModalOpen, closeModal }) => {
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [emailErrorMessage, seEmailErrorMessage] = useState("");
  const [telegram, setTelegram] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setNameErrorMessage();
    seEmailErrorMessage();

    let error = false;
    if (name.trim().length === 0) {
      setNameErrorMessage(t("demo.errorMessageRequired"));
      error = true;
    }
    if (phoneNumber.trim().length === 0) {
      seEmailErrorMessage(t("demo.errorMessageRequired"));
      error = true;
    }

    if (error) {
      return;
    } else {
      try {
        setIsSubmitting(true);
        // Track the event in analytics
        trackEvent("demo-request-form-filled", { name, phoneNumber, telegram });

        // Send form data to backend for email processing
        await sendDemoRequest({ name, phoneNumber, telegram });

        // Show success message
        setSuccess(true);
      } catch (error) {
        console.error("Failed to submit demo request:", error);
        // You can add error handling here if needed
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal}>
      <Heading
        size={2}
        text={success ? t("demo.success.title") : t("demo.title")}
        marginBottom={1}
      />
      {success ? (
        <>
          <Caption>{t("demo.success.caption")}</Caption>
          <Button
            onClick={() => {
              closeModal();
              setSuccess(false);
              setPhoneNumber("");
              setName("");
              setTelegram("");
            }}
            text={t("demo.success.done")}
          />
        </>
      ) : (
        <>
          <InputField
            label={t("demo.nameLabel")}
            placeholder={t("demo.namePlaceholder")}
            value={name}
            onChange={setName}
            required={true}
            errormessage={nameErrorMessage}
          />
          <InputField
            label={t("demo.phoneLabel")}
            placeholder={"+7"}
            value={phoneNumber}
            onChange={setPhoneNumber}
            required={true}
            errormessage={emailErrorMessage}
            type="tel"
          />
          <InputField
            label={t("Telegram")}
            placeholder={"@username"}
            value={telegram}
            onChange={setTelegram}
          />
          <Button
            onClick={() => {
              handleSubmit();
            }}
            text={t("demo.submitButton")}
            disabled={isSubmitting}
          />
        </>
      )}
    </Modal>
  );
};

const Caption = styled.div`
  font-size: 16px;
  line-height: 150%;
  margin-top: 16px;
  margin-bottom: 24px;

  /* Grey */
  color: ${COLORS.grey};
`;
